import { SecureTenantStore } from '@infra/persistence/SecureTenantStore';
import {
  PARAMETRES_DTS_PAR_DEFAUT,
  ParametresDtsInvalideError,
  resoudreParametresDts,
  type ParametresDts,
  type SaisieParametresDts,
} from '@domain/fiscalite/DtsParametres';
import { logger } from '@infra/telemetry/Logger';

const KEY = 'fiscal.dts_parametres';

/** Réglages DTS de l'entreprise (ristourne AF, plafond CNAMGS) ; valeur stockée invalide : décisions par défaut, journalisé. */
export async function loadParametresDts(tenantId: string): Promise<ParametresDts> {
  const raw = await SecureTenantStore.getJson<unknown>(tenantId, KEY, null);
  if (raw === null || typeof raw !== 'object' || Array.isArray(raw)) return PARAMETRES_DTS_PAR_DEFAUT;
  try {
    return resoudreParametresDts(raw as SaisieParametresDts);
  } catch (err) {
    if (!(err instanceof ParametresDtsInvalideError)) throw err;
    logger.warn({ event: 'parametres_dts_invalides', message: err.message });
    return PARAMETRES_DTS_PAR_DEFAUT;
  }
}

/** Enregistre les réglages (validés avant écriture) ; lève `ParametresDtsInvalideError`. */
export async function saveParametresDts(
  tenantId: string,
  saisie: SaisieParametresDts,
): Promise<ParametresDts> {
  const parametres = resoudreParametresDts(saisie);
  await SecureTenantStore.setJson(tenantId, KEY, {
    ristourneAf: {
      option: parametres.ristourneAf.option,
      montantAllocationsFamilialesSaisi: parametres.ristourneAf.montantAllocationsFamilialesSaisi,
    },
    plafondCnamgs: { option: parametres.plafondCnamgs.option },
  });
  return parametres;
}
